import { PageType } from '../components/QuickSlotSetupModal.js';

var EDITOR_CONFIG = {
    CHECKOUT: { type: "information", collection: "checkout" },
    THANK_YOU_PAGE: { type: "thank-you", collection: "thank-you-page" },
    ORDER_STATUS_PAGE: { type: "order-status", collection: "order-status-page" },
};
var getSlotType = function (widgetType) {
    switch (widgetType) {
        case "MULTI_PRODUCT_UPSELL":
        case "PRODUCT_UPSELL":
            return "/product-upsell";
        case "BUNDLE":
            return "/bundle";
        case "RECOMMENDATIONS":
        case "PRODUCT_RECOMMENDATION":
            return "/product-recommendations";
        case "BANNER":
            return "/banner";
        case "ANNOUNCEMENT_BAR":
            return "/announcement-bar";
        case "CUSTOM_SLOT":
        case "DUPLICATE_SLOT":
        default:
            return "/slot";
    }
};
var getEditorRedirectionUrl = function (pageType, shopifyApiKey, platformStoreId, checkoutProfileId, shopifyAppId, widgetType) {
    var storeName = platformStoreId === null || platformStoreId === void 0 ? void 0 : platformStoreId.replace(".myshopify.com", "");
    var slotType = getSlotType(widgetType);
    switch (pageType) {
        case PageType.PRE_PURCHASE_CART_DRAWER_PAGE:
            return "https://".concat(platformStoreId, "/admin/themes/current/editor?context=apps&template=product&activateAppId=").concat(shopifyApiKey, "/cart-drawer");
        case PageType.PRE_PURCHASE_CART_PAGE:
            return "https://".concat(platformStoreId, "/admin/themes/current/editor?addAppBlockId=").concat(encodeURIComponent(shopifyApiKey + slotType), "&template=cart&target=sectionId");
        case PageType.PRE_PURCHASE_PRODUCT_PAGE:
            // Quantity discount is an app embed, so it is activated instead of being added as a section block
            if (widgetType === "QUANTITY_DISCOUNT") {
                return "https://".concat(platformStoreId, "/admin/themes/current/editor?context=apps&template=product&activateAppId=").concat(shopifyApiKey, "/quantity-discount");
            }
            else {
                return "https://".concat(platformStoreId, "/admin/themes/current/editor?addAppBlockId=").concat(encodeURIComponent(shopifyApiKey + slotType), "&template=product&target=sectionId");
            }
        case PageType.POST_PURCHASE_PAGE1:
            return "https://admin.shopify.com/store/".concat(storeName, "/settings/checkout#post-purchase-page");
        default:
            var config = EDITOR_CONFIG[pageType];
            if (config) {
                var queryParams = "?context=apps&collection=".concat(config.collection, "&page=").concat(config.type, "&app=").concat(shopifyAppId);
                if (checkoutProfileId) {
                    return "https://admin.shopify.com/store/".concat(storeName, "/settings/checkout/editor/profiles/").concat(checkoutProfileId).concat(queryParams);
                }
                else {
                    return "https://".concat(platformStoreId, "/admin/settings/checkout/editor").concat(queryParams);
                }
            }
            return "";
    }
};

export { getEditorRedirectionUrl, getSlotType };
//# sourceMappingURL=editorRedirectionurl.js.map
